import PropTypes from 'prop-types';
import ExcursionList from '../../common/excursionList';

const ExcursionListView = ({ excursions, labels, siteId, isMobileApp }) => {
  return (
    <div className="gw-excursion-list-view uikit-box">
      <ExcursionList
        excursions={excursions}
        readMoreLabel={labels.readMoreLabel}
        siteId={siteId}
        isMobileApp={isMobileApp}
      />
    </div>
  );
};

ExcursionListView.propTypes = {
  excursions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
      description: PropTypes.string,
      heading: PropTypes.string,
      imageUrl: PropTypes.string,
      imageCloudinaryUriTemplate: PropTypes.string,
    }),
  ).isRequired,
  labels: PropTypes.shape({
    readMoreLabel: PropTypes.string,
  }).isRequired,
  siteId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isMobileApp: PropTypes.bool.isRequired,
};

export default ExcursionListView;
